import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ApiCallingService } from "../../services/api-calling.service";
import { ConfigApi } from "../../config-api";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "../../../environments/environment";
import * as mapboxgl from "mapbox-gl";
import * as MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import { ToastrService } from "ngx-toastr";
import { Globals } from "../../../app/common/global";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { IDropdownSettings } from "ng-multiselect-dropdown";

interface StoreInfo {
  storeName: string | null;
  countryIsoCode: string | null;
  storeDescription: string | null;
  storeImage: string | null;
  storeLocation: string | null;
  brand_name?: string[] | null;
  storeCategoryIds?: string[] | null;
  storeCategoryNames?: string[] | null;
  latitude?: number;
  longitude?: number;
  deliveryTiming?: string | null;
  _id?: string;
}

interface StoreCategoryOption {
  _id: string;
  name: string;
}

interface StorePricing {
  min_km?: number;
  max_km?: number;
  price?: number;
  vatPercentage?: number;
  isExclusive?: boolean;
}

@Component({
  selector: "app-vending-store",
  templateUrl: "./vending-store.component.html",
  styleUrls: ["./vending-store.component.css"],
})
export class VendingStoreComponent implements OnInit {
  private mapboxAccessToken = environment.mapbox.accessToken;
  userDetails: any;
  storeData: StoreInfo = {
    storeName: null,
    storeDescription: null,
    countryIsoCode: null,
    storeImage: null,
    storeLocation: null,
    brand_name: [],
    storeCategoryIds: [],
    storeCategoryNames: [],
    latitude: 0,
    longitude: 0,
    deliveryTiming: null,
  };

  tempStoreData: StoreInfo = {
    storeName: null,
    storeDescription: null,
    countryIsoCode: null,
    storeImage: null,
    storeLocation: null,
    brand_name: [],
    storeCategoryIds: [],
    storeCategoryNames: [],
    latitude: 0,
    longitude: 0,
    deliveryTiming: null,
  };
  pricingErrorMessage: string = "";
  pricingData: StorePricing[] = [];
  tempPricingData: StorePricing[] = [];
  selectedImageFile: File | null = null;
  imagePreview: string | null = null;
  isDonationShowingToUser: boolean = false;
  isUpdatingDonationVisibility: boolean = false;
  isSendingLowInventoryReport: boolean = false;

  editingPricingIndex: number = -1;
  loading: boolean = false;
  storeModalTitle: string = "";

  validationErrors: {
    storeName: boolean;
    storeDescription: boolean;
    storeLocation: boolean;
    brand_name: boolean;
    storeCategoryIds: boolean;
    storeImage: boolean;
    pricing: boolean;
    deliveryTiming: boolean;
    countryIsoCode: boolean;
  } = {
    storeName: false,
    storeDescription: false,
    storeLocation: false,
    brand_name: false,
    storeCategoryIds: false,
    storeImage: false,
    pricing: false,
    deliveryTiming: false,
    countryIsoCode: false,
  };

  map: any;
  lat: number = 0;
  lng: number = 0;
  locationRequiredError: boolean = false;
  currency: any = "";
  allcountry: any[] = [];

  @ViewChild("createStoreModal") createStoreModal!: TemplateRef<any>;
  brandOptions: string[] = [
    "Frekis",
    "Desibox",
    "Sharekayak",
    // "Smidig",
    "OdeServices",
  ];
  categoryOptions: StoreCategoryOption[] = [];
  selectedCategoryItems: StoreCategoryOption[] = [];
  categoryDropdownSettings: IDropdownSettings = {};

  constructor(
    private apiService: ApiCallingService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    public Globals: Globals,
    private router: Router,

    private http: HttpClient,
  ) {
    this.currency = this.Globals.getUser()?.countryObject?.currency;

    let data = localStorage.getItem("Auth-user");
    if (!data) {
      return;
    }
    try {
      this.userDetails = JSON.parse(data);
    } catch (error) {
      console.error(error);
    }
  }

  ngOnInit(): void {
    this.categoryDropdownSettings = {
      singleSelection: false,
      idField: "_id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "Unselect All",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      closeDropDownOnSelection: false,
    };
    this.getStoreCategories();
    if (this.userDetails) {
      this.getStoreDetails();
    }
    this.getCountries();
  }

  hasStoreData(): boolean {
    return (
      this.storeData !== null &&
      (this.storeData.storeName !== null ||
        this.storeData.storeDescription !== null ||
        this.storeData.storeImage !== null ||
        this.storeData.storeLocation !== null ||
        this.storeData.countryIsoCode !== null)
    );
  }

  getStoreDetails() {
    this.apiService
      .callAPI(
        {},
        "GET",
        ConfigApi.URLS.VENDING.STORE_LIST +
          "?operator_id=" +
          this.userDetails._id,
      )
      .subscribe(
        (res: any) => {
          const data = res?.data;

          console.log(
            "🚀 ~ VendingStoreComponent ~ getStoreDetails ~ data:",
            data,
          );
          if (data) {
            const {
              storeName,
              storeDescription,
              storeImage,
              storeAddress,
              storeLocation = { coordinates: [0, 0] },
              prices,
              brand_name,
              storeCategoryIds,
              deliveryTiming,
              isDonationShowingToUser,
              _id,
            } = data;

            const normalizedStoreCategoryIds = Array.isArray(storeCategoryIds)
              ? storeCategoryIds.map((category: any) =>
                  typeof category === "string" ? category : category?._id,
                )
              : [];
            const normalizedStoreCategoryNames = Array.isArray(storeCategoryIds)
              ? storeCategoryIds
                  .map((category: any) =>
                    typeof category === "string"
                      ? this.categoryOptions.find(
                          (option) => option._id === category,
                        )?.name
                      : category?.name,
                  )
                  .filter((name: string | undefined): name is string => !!name)
              : [];

            this.storeData = {
              storeName,
              storeDescription,
              storeImage,
              storeLocation: storeAddress,
              latitude: storeLocation.coordinates?.[1] || 0,
              longitude: storeLocation.coordinates?.[0] || 0,
              countryIsoCode:
                data.country_iso_code ||
                data.countryObject?.iso ||
                data.country?.iso,
              brand_name,
              storeCategoryIds: normalizedStoreCategoryIds,
              storeCategoryNames: normalizedStoreCategoryNames,
              deliveryTiming,
              _id,
            };
            this.isDonationShowingToUser = !!isDonationShowingToUser;

            this.pricingData = prices || [];
          } else {
            this.storeData = {
              storeName: null,
              storeDescription: null,
              storeImage: null,
              storeLocation: null,
              brand_name: [],
              storeCategoryIds: [],
              storeCategoryNames: [],
              latitude: 0,
              longitude: 0,
              deliveryTiming: null,
              countryIsoCode: null,
            };

            this.pricingData = [];
          }
        },
        (error: any) => {
          console.error("Error fetching store details:", error);
          this.storeData = {
            storeName: null,
            storeDescription: null,
            storeImage: null,
            storeLocation: null,
            brand_name: [],
            storeCategoryIds: [],
            storeCategoryNames: [],
            latitude: 0,
            longitude: 0,
            deliveryTiming: null,
            countryIsoCode: null,
          };
        },
      );
  }

  closeBtnClick() {
    this.modalService.dismissAll();
    this.resetModalData();
  }

  resetModalData() {
    this.tempStoreData = {
      storeName: null,
      storeDescription: null,
      storeImage: null,
      storeLocation: null,
      brand_name: [],
      storeCategoryIds: [],
      storeCategoryNames: [],
      latitude: 0,
      longitude: 0,
      deliveryTiming: null,
      countryIsoCode: null,
    };
    this.tempPricingData = [];
    this.editingPricingIndex = -1;
    this.selectedImageFile = null;
    this.imagePreview = null;
    this.selectedCategoryItems = [];
    this.locationRequiredError = false;
    this.resetValidationErrors();
  }

  resetValidationErrors() {
    this.validationErrors = {
      storeName: false,
      storeDescription: false,
      storeLocation: false,
      brand_name: false,
      storeCategoryIds: false,
      storeImage: false,
      pricing: false,
      deliveryTiming: false,
      countryIsoCode: false,
    };
  }

  openModal(content: TemplateRef<any>, title: string) {
    this.modalService.open(content, {
      centered: true,
      backdrop: "static",
      size: "lg",
    });
  }

  openCreateStoreModal(pricing?: StorePricing, index: number = -1) {
    this.storeModalTitle = this.hasStoreData()
      ? "Update Store Information"
      : "Add Store Information";

    this.tempStoreData = {
      storeName: this.storeData.storeName,
      storeDescription: this.storeData.storeDescription,
      storeImage: this.storeData.storeImage,
      storeLocation: this.storeData.storeLocation,
      latitude: this.storeData.latitude || 0,
      longitude: this.storeData.longitude || 0,
      countryIsoCode: this.storeData.countryIsoCode,
      brand_name: this.storeData.brand_name
        ? [...this.storeData.brand_name]
        : [],
      storeCategoryIds: this.storeData.storeCategoryIds
        ? [...this.storeData.storeCategoryIds]
        : [],
      storeCategoryNames: this.storeData.storeCategoryNames
        ? [...this.storeData.storeCategoryNames]
        : [],
      deliveryTiming: this.storeData.deliveryTiming,
    };
    this.syncSelectedCategoriesFromIds();

    if (pricing && index !== -1) {
      this.tempPricingData = JSON.parse(JSON.stringify(this.pricingData));
      this.editingPricingIndex = index;
    } else {
      this.tempPricingData =
        this.pricingData.length > 0
          ? JSON.parse(JSON.stringify(this.pricingData))
          : [this.createEmptyPricing()];
    }

    this.imagePreview = this.tempStoreData.storeImage;
    this.selectedImageFile = null;

    if (this.tempStoreData.latitude && this.tempStoreData.longitude) {
      this.lat = this.tempStoreData.latitude;
      this.lng = this.tempStoreData.longitude;
    }

    this.resetValidationErrors();
    this.openModal(this.createStoreModal, this.storeModalTitle);

    setTimeout(() => {
      this.initializeMap();
    }, 300);
  }

  openLowStockAlertConfirm(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      centered: true,
      backdrop: "static",
    });
  }

  confirmSendLowInventoryReport(modalRef: any): void {
    if (!this.userDetails?._id) {
      this.toastr.error("Operator not found.");
      return;
    }
    this.isSendingLowInventoryReport = true;
    this.apiService
      .callAPI(
        { operator_id: this.userDetails._id },
        "POST",
        ConfigApi.URLS.VENDING.SEND_LOW_INVENTORY_REPORT,
      )
      .subscribe(
        () => {
          this.isSendingLowInventoryReport = false;
          modalRef.close();
          this.toastr.success("Low inventory report sent successfully.");
        },
        () => {
          this.isSendingLowInventoryReport = false;
          this.toastr.error("Failed to send low inventory report.");
        },
      );
  }

  createEmptyPricing(): StorePricing {
    return {
      min_km: undefined,
      max_km: undefined,
      price: undefined,
      vatPercentage: undefined,
      isExclusive: true,
    };
  }

  addPriceRange() {
    if (this.tempPricingData.length > 0) {
      const lastPricing = this.tempPricingData[this.tempPricingData.length - 1];

      if (
        lastPricing.min_km === undefined ||
        lastPricing.min_km === null ||
        lastPricing.max_km === undefined ||
        lastPricing.max_km === null ||
        lastPricing.price === undefined ||
        lastPricing.price === null ||
        lastPricing.max_km <= 0 ||
        lastPricing.price < 0 ||
        (lastPricing.vatPercentage ?? 0) < 0 ||
        (this.tempPricingData.length > 1 && lastPricing.min_km <= 0)
      ) {
        this.validationErrors.pricing = true;
        this.pricingErrorMessage =
          "Please fill all fields in the above price range before adding a new one.";
        return;
      }

      if (lastPricing.min_km >= lastPricing.max_km) {
        this.validationErrors.pricing = true;
        this.pricingErrorMessage =
          "In the above range, Maximum KM must be greater than Minimum KM";
        return;
      }
    }

    this.tempPricingData.push(this.createEmptyPricing());
    this.validationErrors.pricing = false;
    this.pricingErrorMessage = "";
  }

  removePriceRange(index: number) {
    if (this.tempPricingData.length > 1) {
      this.tempPricingData.splice(index, 1);
      this.clearPricingError();
    }
  }

  validateStoreInfo(): boolean {
    let isValid = true;

    this.validationErrors = {
      storeName: false,
      storeDescription: false,
      storeLocation: false,
      storeImage: false,
      brand_name: false,
      storeCategoryIds: false,
      pricing: false,
      countryIsoCode: false,
      deliveryTiming: false,
    };

    if (
      !this.tempStoreData.storeName ||
      this.tempStoreData.storeName.trim() === ""
    ) {
      this.validationErrors.storeName = true;
      isValid = false;
    }

    if (
      !this.tempStoreData.brand_name ||
      this.tempStoreData.brand_name.length === 0
    ) {
      this.validationErrors.brand_name = true;
      isValid = false;
    }

    if (
      !this.tempStoreData.storeCategoryIds ||
      this.tempStoreData.storeCategoryIds.length === 0
    ) {
      this.validationErrors.storeCategoryIds = true;
      isValid = false;
    }

    if (
      !this.tempStoreData.storeDescription ||
      this.tempStoreData.storeDescription.trim() === ""
    ) {
      this.validationErrors.storeDescription = true;
      isValid = false;
    }

    if (
      !this.tempStoreData.deliveryTiming ||
      this.tempStoreData.deliveryTiming.trim() === ""
    ) {
      this.validationErrors.deliveryTiming = true;
      isValid = false;
    }

    if (
      !this.tempStoreData.countryIsoCode ||
      this.tempStoreData.countryIsoCode.trim() === ""
    ) {
      this.validationErrors.countryIsoCode = true;
      isValid = false;
    }

    if (
      !this.tempStoreData.storeLocation ||
      this.tempStoreData.storeLocation.trim() === "" ||
      !this.lat ||
      this.lat === 0 ||
      !this.lng ||
      this.lng === 0
    ) {
      this.validationErrors.storeLocation = true;
      this.locationRequiredError = true;
      isValid = false;
    }

    if (
      !this.hasStoreData() &&
      !this.selectedImageFile &&
      !this.tempStoreData.storeImage
    ) {
      this.validationErrors.storeImage = true;
      isValid = false;
    }

    return isValid;
  }

  validatePricing(): boolean {
    this.validationErrors.pricing = false;
    this.pricingErrorMessage = "";

    if (this.tempPricingData.length === 0) {
      this.validationErrors.pricing = true;
      this.pricingErrorMessage = "Please add at least one pricing range";
      return false;
    }

    for (let i = 0; i < this.tempPricingData.length; i++) {
      const pricing = this.tempPricingData[i];

      if (
        pricing.min_km === undefined ||
        pricing.max_km === undefined ||
        pricing.price === undefined ||
        pricing.vatPercentage === undefined
      ) {
        this.validationErrors.pricing = true;
        this.pricingErrorMessage = `Range ${i + 1}: All fields are required`;
        return false;
      }

      if (
        pricing.min_km < 0 ||
        pricing.max_km < 0 ||
        pricing.price < 0 ||
        pricing.vatPercentage < 0
      ) {
        this.validationErrors.pricing = true;
        this.pricingErrorMessage = `Range ${
          i + 1
        }: All values must be non-negative`;
        return false;
      }

      if (pricing.min_km >= pricing.max_km) {
        this.validationErrors.pricing = true;
        this.pricingErrorMessage = `Range ${
          i + 1
        }: Maximum KM must be greater than Minimum KM`;
        return false;
      }

      if (pricing.vatPercentage > 100) {
        this.validationErrors.pricing = true;
        this.pricingErrorMessage = `Range ${
          i + 1
        }: VAT cannot be greater than 100%`;
        return false;
      }

      for (let j = 0; j < this.tempPricingData.length; j++) {
        if (i === j) continue;

        const otherPricing = this.tempPricingData[j];

        if (
          (pricing.min_km >= (otherPricing.min_km ?? 0) &&
            pricing.min_km < (otherPricing.max_km ?? 0)) ||
          (pricing.max_km > (otherPricing.min_km ?? 0) &&
            pricing.max_km <= (otherPricing.max_km ?? 0)) ||
          (pricing.min_km <= (otherPricing.min_km ?? 0) &&
            pricing.max_km >= (otherPricing.max_km ?? 0))
        ) {
          this.validationErrors.pricing = true;
          this.pricingErrorMessage = `Overlapping detected between Range ${
            i + 1
          } and Range ${j + 1}`;
          return false;
        }
      }
    }

    for (let i = 0; i < this.tempPricingData.length - 1; i++) {
      const currentRange = this.tempPricingData[i];
      const nextRange = this.tempPricingData[i + 1];

      if (currentRange.max_km !== nextRange.min_km) {
        this.validationErrors.pricing = true;
        this.pricingErrorMessage = `There is a gap between Range ${
          i + 1
        } and Range ${
          i + 2
        }. Ensure that the maximum value of a range matches the minimum value of the next range.`;
        return false;
      }
    }

    return true;
  }

  saveStoreAndPricing() {
    const isStoreInfoValid = this.validateStoreInfo();
    const isPricingValid =
      this.tempPricingData.length > 0 ? this.validatePricing() : true;

    if (!isStoreInfoValid || !isPricingValid) {
      return;
    }

    this.tempStoreData.latitude = this.lat;
    this.tempStoreData.longitude = this.lng;

    const formData = new FormData();

    formData.append("storeName", this.tempStoreData.storeName || "");
    formData.append(
      "storeDescription",
      this.tempStoreData.storeDescription || "",
    );
    formData.append(
      "brand_name",
      JSON.stringify(this.tempStoreData.brand_name || []),
    );
    formData.append(
      "storeCategoryIds",
      JSON.stringify(this.tempStoreData.storeCategoryIds || []),
    );
    formData.append(
      "country_iso_code",
      this.tempStoreData.countryIsoCode?.toUpperCase() || "",
    );

    formData.append("deliveryTiming", this.tempStoreData.deliveryTiming || "");

    formData.append("storeAddress", this.tempStoreData.storeLocation || "");
    formData.append("latitude", String(this.tempStoreData.latitude ?? ""));
    formData.append("longitude", String(this.tempStoreData.longitude ?? ""));
    formData.append("operator_id", this.userDetails._id);
    if (this.selectedImageFile) {
      formData.append("storeImage", this.selectedImageFile);
    }

    const sortedPrices =
      this.tempPricingData.length > 0
        ? [...this.tempPricingData].sort(
            (a, b) => (a?.min_km ?? 0) - (b?.min_km ?? 0),
          )
        : [];

    formData.append("prices", JSON.stringify(sortedPrices));

    this.apiService
      .callAPI(formData, "POST", ConfigApi.URLS.VENDING.CREATE_STORE)
      .subscribe(
        (res: any) => {
          if (this.apiService.handleSuccess(res)) {
            this.toastr.success(res.msg);
            this.getStoreDetails();
            this.closeBtnClick();
          } else {
            this.toastr.error(res.msg);
            console.error(res.msg);
          }
        },
        (err) => {
          this.toastr.error(err.error.msg || "something went wrong");
          console.error(err.error.msg);
        },
      );
  }

  saveAllPricing(): Promise<any> {
    return new Promise((resolve, reject) => {
      let payload: any = {
        pricingData: this.pricingData,
        user_id: this.userDetails._id,
      };

      const apiUrl = ConfigApi.URLS.VendingStore.CREATE_STORE_PRICING;

      this.apiService.callAPI(payload, "POST", apiUrl).subscribe(
        (res: any) => {
          if (res) {
            resolve(res);
          } else {
            reject("Failed to save pricing data");
          }
        },
        (error: any) => {
          console.error("Error updating store pricing:", error);
          reject(error);
        },
      );
    });
  }

  onImageSelect(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.selectedImageFile = file;
      this.validationErrors.storeImage = false;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imagePreview = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  onBrandSelectionChange(event: any) {
    const value = event.target.value;
    const checked = event.target.checked;

    if (!this.tempStoreData.brand_name) {
      this.tempStoreData.brand_name = [];
    }

    if (checked) {
      if (!this.tempStoreData.brand_name.includes(value)) {
        this.tempStoreData.brand_name.push(value);
      }
    } else {
      this.tempStoreData.brand_name = this.tempStoreData.brand_name.filter(
        (b) => b !== value,
      );
    }

    this.validationErrors.brand_name =
      this.tempStoreData.brand_name.length === 0;
  }

  onCategorySelectionChange(event: any) {
    const category = event as StoreCategoryOption;
    if (!category?._id) {
      return;
    }

    const selectedIds = new Set(this.tempStoreData.storeCategoryIds || []);
    selectedIds.add(category._id);
    this.tempStoreData.storeCategoryIds = Array.from(selectedIds);
    this.validationErrors.storeCategoryIds = false;
  }

  onCategoryDeselectionChange(event: any) {
    const category = event as StoreCategoryOption;
    if (!category?._id) {
      return;
    }

    this.tempStoreData.storeCategoryIds = (
      this.tempStoreData.storeCategoryIds || []
    ).filter((categoryId) => categoryId !== category._id);

    this.validationErrors.storeCategoryIds =
      this.tempStoreData.storeCategoryIds.length === 0;
  }

  onCategorySelectAll(items: StoreCategoryOption[]) {
    this.selectedCategoryItems = [...items];
    this.tempStoreData.storeCategoryIds = items.map((item) => item._id);
    this.validationErrors.storeCategoryIds = false;
  }

  onCategoryDeselectAll() {
    this.selectedCategoryItems = [];
    this.tempStoreData.storeCategoryIds = [];
    this.validationErrors.storeCategoryIds = true;
  }

  private syncSelectedCategoriesFromIds() {
    const selectedIds = new Set(this.tempStoreData.storeCategoryIds || []);
    this.selectedCategoryItems = this.categoryOptions.filter((category) =>
      selectedIds.has(category._id),
    );
  }

  getStoreCategories() {
    this.apiService
      .callAPI({}, "GET", ConfigApi.URLS.VENDING.STORE_CATEGORY_LIST)
      .subscribe(
        (res: any) => {
          const categories = Array.isArray(res?.data)
            ? res.data
            : Array.isArray(res?.data?.docs)
              ? res.data.docs
              : [];
          this.categoryOptions = categories
            .map((category: any) => ({
              _id: category?._id,
              name: category?.name,
            }))
            .filter(
              (category: StoreCategoryOption) =>
                !!category._id && !!category.name,
            );
          this.syncSelectedCategoriesFromIds();

          if (this.storeData.storeCategoryIds?.length) {
            this.storeData.storeCategoryNames = this.storeData.storeCategoryIds
              .map(
                (categoryId) =>
                  this.categoryOptions.find(
                    (option) => option._id === categoryId,
                  )?.name,
              )
              .filter((name: string | undefined): name is string => !!name);
          }
        },
        (error: any) => {
          console.error("Error fetching store categories:", error);
          this.categoryOptions = [];
        },
      );
  }

  initializeMap() {
    (mapboxgl as any).accessToken = this.mapboxAccessToken;
    const initialLat = this.lat || 0;
    const initialLng = this.lng || 0;

    try {
      this.map = new mapboxgl.Map({
        container: "storeLocationMap",
        style: "mapbox://styles/mapbox/streets-v11",
        center: [initialLng, initialLat],
        zoom: 12,
      });

      const geocoder = new (MapboxGeocoder as any)({
        accessToken: (mapboxgl as any).accessToken,
        mapboxgl: mapboxgl,
        placeholder: "Search for store location",
        marker: false,
      });

      this.map.addControl(geocoder);

      // Only add marker if we have valid coordinates (not 0,0)
      let marker: mapboxgl.Marker | null = null;
      if (this.lat !== 0 && this.lng !== 0) {
        marker = new mapboxgl.Marker({ draggable: true })
          .setLngLat([initialLng, initialLat])
          .addTo(this.map);
      }

      this.map.flyTo({
        center: [initialLng, initialLat],
        zoom: this.map.getZoom(),
      });

      // Only set up marker events if marker exists
      if (marker) {
        marker.on("dragend", () => {
          const lngLat = marker!.getLngLat();
          this.lat = lngLat.lat;
          this.lng = lngLat.lng;
          this.locationRequiredError = false;
          this.validationErrors.storeLocation = false;
          this.reverseGeocode(lngLat);
        });
      }

      this.map.on("click", (e: any) => {
        this.lat = e.lngLat.lat;
        this.lng = e.lngLat.lng;

        // If marker doesn't exist, create it
        if (!marker) {
          marker = new mapboxgl.Marker({ draggable: true })
            .setLngLat([this.lng, this.lat])
            .addTo(this.map);
        } else {
          marker.setLngLat([this.lng, this.lat]);
        }

        this.locationRequiredError = false;
        this.validationErrors.storeLocation = false;
        this.reverseGeocode(e.lngLat);
      });

      geocoder.on("result", (event: any) => {
        const coordinates = event.result.center;
        this.lng = coordinates[0];
        this.lat = coordinates[1];

        // If marker doesn't exist, create it
        if (!marker) {
          marker = new mapboxgl.Marker({ draggable: true })
            .setLngLat(coordinates)
            .addTo(this.map);
        } else {
          marker.setLngLat(coordinates);
        }

        this.locationRequiredError = false;
        this.validationErrors.storeLocation = false;
        this.tempStoreData.storeLocation = event.result.place_name;
      });

      if (this.tempStoreData.storeLocation && initialLat && initialLng) {
        setTimeout(() => {
          const geocoderInput: any = document.querySelector(
            ".mapboxgl-ctrl-geocoder--input",
          );
          if (geocoderInput) {
            geocoderInput.value = this.tempStoreData.storeLocation;
          }
        }, 500);
      }
    } catch (error) {
      console.error("Error initializing map:", error);
    }
  }

  reverseGeocode(lngLat: any) {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${lngLat.lng},${lngLat.lat}.json?access_token=${this.mapboxAccessToken}`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (data.features.length > 0) {
          this.tempStoreData.storeLocation = data.features[0].place_name;
          const geocoderInput: any = document.querySelector(
            ".mapboxgl-ctrl-geocoder--input",
          );
          if (geocoderInput) {
            geocoderInput.value = data.features[0].place_name;
          }
        } else {
          this.tempStoreData.storeLocation = "No address found";
        }
      })
      .catch((error) => {
        console.error("Error reverse geocoding:", error);
        this.tempStoreData.storeLocation = "Error retrieving address";
      });
  }

  getCountries() {
    this.http.get("assets/countries.json").subscribe((data: any) => {
      this.allcountry = data;
    });
  }

  clearPricingError() {
    this.validationErrors.pricing = false;
    this.pricingErrorMessage = "";
  }

  ngOnDestroy(): void {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  viewCouponList(data: any) {
    const productId = data._id;
    this.router.navigate(["user/vending-store/coupons"], {
      queryParams: { pId: productId },
    });
  }

  formatVatWithPercentage(vat: number | undefined): string {
    if (vat === undefined) {
      return "-";
    }
    return `${vat}%`;
  }
  onDonationVisibilityToggle(value: boolean) {
    // prevent double click
    this.isUpdatingDonationVisibility = true;

    // optimistic UI update
    const previousValue = this.isDonationShowingToUser;
    this.isDonationShowingToUser = value;

    const payload = {
      isDonationShowingToUser: value,
    };

    this.apiService
      .callAPI(
        payload,
        "POST",
        `${ConfigApi.URLS.VENDING_DONATION_SETTLEMENT.UPDATE_STATUS}/${this.storeData._id}`,
      )
      .subscribe(
        (res: any) => {
          this.isUpdatingDonationVisibility = false;

          if (this.apiService.handleSuccess(res)) {
            this.toastr.success(res.msg || "Updated successfully");
          } else {
            // rollback if API returns failure
            this.isDonationShowingToUser = previousValue;
            this.toastr.error(res.msg || "Update failed");
          }
        },
        (error) => {
          console.error(error);

          // rollback on error
          this.isDonationShowingToUser = previousValue;
          this.isUpdatingDonationVisibility = false;
          this.toastr.error(error?.error?.msg || "Something went wrong");
        },
      );
  }
}
